<template>
    <div class="row" id="productImages">
        <div class="col-lg-12">
            <img id="product-image" ref="image" :src="image" alt="">
        </div>
        <div class="col-lg-12" v-if="images.length > 1">
            <div class="row controls">
                <div class="col-3" v-for="(image, key) in images" :key="key">
                    <img data-target="#product-image" data-role="image-source" :src="image" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ElasticImage from '@Modules/elastic-image'

export default {

    props: ['images'],

    computed: {
        image() {
            return this.images.length ? this.images[0] : ''
        }
    },

    mounted() {
        new ElasticImage(this.$refs.image);
    }
}
</script>

<style scoped>
    img {
        width: 100%;
        height: auto;
        margin-bottom: 30px;
    }
</style>
